const axios = require("axios")

class DonationReason {
  constructor() {
    this.form = document.querySelector("[data-donation-reason]")
    if (!this.form) {
      return
    }

    this.question = document.querySelector("[data-donation-reason-question]")
    this.button = document.querySelector("[data-donation-reason-btn]")
    this.other = document.querySelector("[data-donation-reason-other]")
    this.thankYou = document.querySelector("[data-donation-reason-thank]")

    this.hideClass = "d-none"
    this.otherValue = "Other"

    this.button.addEventListener("click", this.onSubmit.bind(this))
    this.question.addEventListener("change", this.onSelectAnswer.bind(this))
  }

  /**
   * Event on click submit button
   */
  onSubmit() {
    this.showThankYou()

    // Get data from the form
    let data = {}
    const formData = new FormData(this.form)
    for (const key of formData.keys()) {
      data[key] = formData.get(key)
    }

    // Send a request to save the answer
    // On failure we ignore the error as this is optional feedback
    axios.post(this.form.getAttribute("action"), data, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
      },
    })
  }

  /**
   * Event on selecting an answer
   */
  onSelectAnswer() {
    if (this.question.value === this.otherValue) {
      this.showOther()
    } else {
      this.hideOther()
    }
  }

  /**
   * Show other reason field
   */
  showOther() {
    this.other.classList.remove(this.hideClass)
  }

  /**
   * Hide other reason field
   */
  hideOther() {
    this.other.classList.add(this.hideClass)
  }

  /**
   * Show thank you message and hide question
   */
  showThankYou() {
    this.thankYou.classList.remove(this.hideClass)
    this.form.classList.add(this.hideClass)
  }
}

export default DonationReason
